export type Address = {
  address_line1: string;
  address_line2: string | null;
  city: string;
  state: string;
  zip_code: string;
  country: string;
};

export type PriorName = {
  first_name: string;
  middle_name: string | null;
  last_name: string;
};

export type Borrower = {
  id: number;
  full_name: string;
  email: string;
};

export enum TwoFactorMethod {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}

export type Nullable<T> = T | null;

export type PartialNullable<T> = { [K in keyof T]?: Nullable<T[K]> };
